import React from "react";

import DispensaryMenuItemCardSkeleton from "components/DispensaryMenuItemCard/DispensaryMenuItemCardSkeleton";

export const DeliveryProductLoadingSkeleton = ({
  items = ["a", "b", "c", "d"],
}: {
  items?: Array<string>;
}) => (
  <>
    {items.map((n: string) => (
      <DispensaryMenuItemCardSkeleton key={n} />
    ))}
  </>
);

export default DeliveryProductLoadingSkeleton;
